// pages/affiliateProgramThankYou/AffiliateProgramThankYou.jsx
import React from "react";
import "./affiliateProgramThankYou.css";
import { Link } from "react-router-dom";

export default function ThankYou() {
  return (
    <div className="page-wrapper">
      <div className="page-content">
        <div className="thankyou-card">
          <h1 className="thankyou-title">Thank you!</h1>
          <p className="thankyou-subtitle">Your application has been received.</p>

          <h2 className="thankyou-heading">What happens next:</h2>
          <ul className="thankyou-list">
            <li><strong>Review time:</strong> We review applications within <strong>72 hours</strong>.</li>
            <li><strong>If approved:</strong> You’ll receive your <strong>unique promo code</strong> and access to your <strong>Affiliate Dashboard</strong>.</li>
            <li><strong>Payouts:</strong> Processed <strong>30 days after purchase</strong> if the subscription is still active.</li>
          </ul>

          <Link to="/" className="thankyou-back">
            ← Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
